var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('Layout',[_c('Content',[_c('div',{staticClass:"unauthorized"},[_c('p',[_vm._v("暂无权限，请联系管理员")])])]),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }